@if (_active) {
  <kendo-window
    [class.editFieldsModeClass]="_pageState == 4"
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form -->
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-6 special_col_padding"
          [class.col-12]="_pageState == 2 || _pageState == 4">
          <div class="border_sections margin-top-4 bordered-With-charts">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Dispose To
                  @if (canAccess('disposeTo', 'update')) {
                    <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1" class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if (canAccess('disposeTo', 'update') &&  this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4) {
                      <li (click)="_onEditForms()"
                        [class.ViewModelHiddenElement]="_pageState != 2">
                        Edit Forms
                      </li>
                    }
                    @if (this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4) {
                      <li class="wikiButton" (click)="_onEditFields()" [class.ViewModeHiddenElement]="_pageState != 2"
                        >
                        Edit Fields
                      </li>
                    }
                    <li class="wikiButton"
                      (click)="_returnAdNew()"
                      [class.ViewModeHiddenElement]="_pageState != 4">
                      Close Edit Fields
                    </li>
                    <!-- <li [class.ViewModeHiddenElement]="_pageState == 1">Edit Forms</li> -->
                    <!-- <li class="wikiButton">Wiki</li> -->
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                        (click)="_viewInactiveFields();_deactivatedFieldsForm=true">
                        View Inactive Fields
                      </li>
                    }
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFormTabsGridData?.length == 0"
                        (click)="_viewInactiveFormTabs();_deactivatedFormTabsForm=true"
                        >
                        View Inactive Form Tabs
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      <button kendoButton
                        class="steps_buttons_class"
                        (click)="_onCancel()">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                        @if (canAccess('disposeTo', 'create')) {
                          <button
                            kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & Copy</span>
                            </button>
                          }
                          @if (canAccess('disposeTo', 'create')) {
                            <button
                              kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndNew')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & New</span>
                              </button>
                            }
                            <button kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndClose')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & Close</span>
                              </button>
                              <button kendoButton
                                class="steps_buttons_class"
                                [disabled]="_pageState == 4 ? true : false"
                                (click)="_onSave('save')">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save</span>
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="formsMenuSeparator"></div>
                        </div>
                      </div>
                      <div class="row row_padding">
                        <fieldset class="col-12"
                          [class.col-6-imp]="_pageState == 2 || _pageState == 4">
                          <!--All Sites DropDown-->
                          <sites-dropdown #kendo_combo_SiteCode
                            [(ngModel)]="_siteSelected"
                            (siteChanged)="_handleSitesChange($event)"
                            [ngModelOptions]="{standalone: true}"
                            [textField]="'code'"
                            [valueField]="'id'"
                            [inputClass]="'MultiSiteCustomComboBox k-combobox bordered newFormControlWidth'"
                            [layout]="'form-group'"
                            [labelText]="'Site Code'">
                          </sites-dropdown>
                          <div KendoToolTip class="form-group from_but_container special_style_formgroup margin-top-10">
                            <label for="code" class="control-label">{{getLabel("LBL_DisposeToCode")?.currentText}}</label>
                            <input #kendo_BarcodeGen_Dispose_Number
                              [class.ViewModeDisabledControl]="_pageState == 1"
                              type="text"
                              class="k-textbox writebox min-width-0 newFormControlWidth"
                              [placeholder]="'code'"
                              formControlName="code"
                              entityName="code"
                              [readonly]="_pageState == 1 ? true : false"
                              required
                              [formControl]="_disposeToCode" />
                              <a title="Generate Barcode"
                                class="cursor-pointer"
                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                (click)="_generateBarcodeClick()">
                                <img class="searchIcon"
                                  [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                </a>
                                <a title="Edit {{getLabel('LBL_DisposeToCode')?.currentText}}"
                                  [class.editfieldsIconvisible]="_pageState == 4"
                                  class="editFieldsIcon"
                                  (click)="_openRenameForm('LBL_DisposeToCode', true)">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                  </a>
                                </div>
                                @if (getAuthByLabel('LBL_DisposeToDesc')?.canView) {
                                  <div KendoToolTip
                                    class="form-group special_style_formgroup">
                                    <label for="description" class="control-label">{{getLabel("LBL_DisposeToDesc")?.currentText}}</label>
                                    <input #kendo_Input_Dispose_Description
                                      [class.ViewModeDisabledControl]="_pageState == 1"
                                      type="text"
                                      class="k-textbox writebox newFormControlWidth"
                                      formControlName="description"
                                      placeholder="Name"
                                      [readonly]="_pageState == 1 ? true : false"
                                      [attr.disabled]="getAuthByLabel('LBL_DisposeToDesc')?.canEdit ? null : 'disabled'"
                                      [attr.required]="getLabel('LBL_DisposeToDesc')?.isRequired ? 'required' : null" />
                                      <a title="Edit {{getLabel('LBL_DisposeToDesc')?.currentText}}"
                                        [class.editfieldsIconvisible]="_pageState == 4"
                                        class="editFieldsIcon"
                                        (click)="_openRenameForm('LBL_DisposeToDesc')">
                                        <img class="searchIcon"
                                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                        </a>
                                      </div>
                                    }
                                  </fieldset>
                                </div>
                              </div>
                            </div>
                            @if (_pageState != 2 && _pageState != 4) {
                              <div class="col-6 special_col_padding"
                                >
                                <div class="border_sections margin-top-4 bordered-With-charts">
                                  @if ((_currentUser && !_currentUser.isEnterprise)) {
                                    <div class="col-12 appliance-Sharts-Container"
                                      >
                                      <div class="tabsSection">
                                        <ul class="tabsectionList">
                                          <li [class.activetabShart]="_SIDActive" class="LS">
                                            Stock item disposed
                                          </li>
                                        </ul>
                                      </div>
                                      @if (_SIDActive && disposeToChartDetail && disposeToChart && _disposeHistoryGridColumns) {
                                        <div (click)="DisposeHistoryOnOpen($event)"
                                          class="stock-item-chart">
                                          <apx-chart [title]="disposeToChart.title"
                                            [series]="disposeToChart.series"
                                            [chart]="disposeToChart.chart"
                                            [xaxis]="disposeToChart.xaxis"
                                            [stroke]="disposeToChart.stroke"
                                          [dataLabels]="disposeToChart.dataLabels"></apx-chart>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                          <div class="example-wrapper">
                            <div class="row no_row_margin">
                              <div class="col-8 col-lg-8 col-xl-8 responsive_style numericboxtab"
                                #kendo_tabstrip_wrapper>
                                @if (_hasCustomTabs()) {
                                  <kendo-tabstrip [tabPosition]="_kendoTabStripPosition"
                                    (tabSelect)="_onTabSelect($event)"
                                    >
                                    @for (tab of _dataTabs; track tab) {
                                      @if (tab.isCustom) {
                                        <kendo-tabstrip-tab [title]="tab.name">
                                          <ng-template kendoTabContent>
                                            <div class="tabcontent">
                                              <fieldset class="contenttabstyle margin-top-10">
                                                <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                  [pageState]="_pageState"
                                                  [accounts]="_selectedAccountIds"
                                                  [formName]="'stock'"
                                                  page="disposeTo"
                                                  [invalidSubmit]="_invalidSubmit"
                                                  (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                  (customFieldsDeleteValue)="_removeCustomField($event)"
                                                  (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                  (customFieldsStatus)="formStatus($event)"
                                                  [_customFieldsValue]="_customFieldsValue">
                                                </asap-custom-fields-form>
                                                <div class="form-group special_style_formgroup">
                                                  <button kendobutton
                                                    class="addNewFieldButton k-button"
                                                    (click)="_addNewField(tab.id)">
                                                    <img class="backimage"
                                                      src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                    </button>
                                                  </div>
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton
                                                      class="addNewFieldButton k-button"
                                                      (click)="_deactivateTab(tab.id, 'stockItems')">
                                                      <img class="backimage"
                                                        src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate Tab</span>
                                                      </button>
                                                    </div>
                                                  </fieldset>
                                                </div>
                                              </ng-template>
                                            </kendo-tabstrip-tab>
                                          }
                                        }
                                      </kendo-tabstrip>
                                    }
                                  </div>
                                  <!-- <div class="col-4 col-lg-4 col-xl-4 responsive_style">
                                  <div class="borderedNotesContainer">
                                    <note
                                      #note
                                      [_pageState]="_pageState"
                                      [_model]="_model"
                                      [_page]="_page"
                                    ></note>
                                  </div>
                                </div> -->
                              </div>
                            </div>
                            <div class="row no_row_margin">
                              <div class="col-12">
                                <button kendobutton
                                  class="addNewtabButton k-button"
                                  (click)="_addNewTab()">
                                  <img class="backimage"
                                    src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                                  </button>
                                </div>
                              </div>
                              <div class="row no_row_margin">
                                <div class="col-12">
                                  <button kendobutton
                                    class="reorderTabButton k-button"
                                    (click)="_reorderingtabs()">
                                    <img class="backimage"
                                      src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    @if (_invalidForm) {
                                      <asap-forms-validation-summary
                                        [form]="_form"
                                        [page]="'disposeTo'"
                                        [customValidation]="_customValidation"
                                        [customFields]="_customFields"
                                        [additionalErrors]="_additionalErrors">
                                      </asap-forms-validation-summary>
                                    }
                                    <!-- <asap-forms-validation-summary
                                    *ngIf="_invalidSubmit"
                                    [form]="_form"
                                    [page]="'disposeTo'"
                                    [isCustom]="true"
                                    [customValidation]="_customValidation"
                                    [customFields]="_customFields"
                                    >
                                  </asap-forms-validation-summary> -->
                                </div>
                              </div>
                            </form>
                            @if (CheckIfWeAreInEditMode()) {
                              <div class="asap-footer">
                                <ul class="asap-footer-content-list">
                                  <li>
                                    <span class="label-footer">Date Added:</span>{{
                                    _model.createdOn |
                                    dateFormat
                                    }}<span class="separator">.</span><span class="label-footer">Added By User:</span>{{
                                    _model.createdUser?
                                    _model.createdUser.userName : null
                                    }}
                                  </li>
                                  <li>
                                    <span class="label-footer">Last Edited:</span>{{
                                    _model.lastUpdatedOn |
                                    dateFormat
                                    }}<span class="separator">.</span><span class="label-footer">Last Edited By User:</span>{{_model.updatedUser? _model.updatedUser.userName : null}}
                                  </li>
                                </ul>
                              </div>
                            }
                            @if (_isDialiog) {
                              <asap-dialog-layout
                                [data]="_dialogModel"
                                [componentName]="_dialogComponentName"
                                (closeDialog)="_closeDialog($event)">
                              </asap-dialog-layout>
                            }
                            @if (_isEditForms || _deactivatedFormTabsForm) {
                              <div class="k-overlay"></div>
                            }
                          </kendo-window>
                        }

                        @if (_editFormActive) {
                          <kendo-window
                            title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                            (close)="_closeCustomFields()"
                            class="customFieldsWindow">
                            <asap-custom-fields [accounts]="_selectedAccountIds"
                              [tabGroup]="_selectedTabId"
                              [labelId]="_selectedLabelId"
                              [labelObjectCode]="_selectedLabelObjectCode"
                              [formName]="'stock'"
                              page="disposeTo"
                              [isCustomfieldsForm]="_isCustomfieldsFormValue"
                              [isCustomtabsForm]="_isAddTabFormValue"
                              [isRenameForm]="_isRenameFormValue"
                              [language]="_language"
                              [isRenameCustomForm]="_isRenameCustomFormValue"
                              [isRenameLabel]="_isRenameLabel"
                              [isMandatory]="_isMandatory"
                              [permissionScope]="_permissionScope"
                              (closePopup)="ClosePopup($event)">
                            </asap-custom-fields>
                          </kendo-window>
                        }

                        @if (_orderingTabsForm) {
                          <kendo-window title="Tab Reordering"
                            (keydown.enter)="$event.preventDefault()"
                            (close)="_closeOrderingTabsForm()">
                            <div class="row no_row_margin py-2 margin-top-4 border_sections">
                              <div class="col-12">
                                <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save & Close</span>
                                </button>
                              </div>
                            </div>
                            <div class="row no_row_margin p-3 margin-top-30">
                              @if (false) {
                                <div class="col-12 margin-top-10">
                                  <div class="form-group">
                                    <label for="itemType" class="control-label">Tab 1</label>
                                    <kendo-combobox [data]="_dataTabsSelected"
                                      [suggest]="true"
                                      [textField]="'name'"
                                      [valueField]="'name'"
                                      placeholder="Accounts/Sites"
                                      class="newFormControlWidth disabled">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              }
                              @for (item of _dataTabs ; track item; let i = $index) {
                                <div class="col-12 margin-top-10">
                                  <div class="form-group">
                                    <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                    <kendo-combobox [data]="_dataTabsSelected"
                                      [suggest]="true"
                                      [textField]="'name'"
                                      [valueField]="'name'"
                                      [placeholder]="item.name"
                                      required
                                      class="bordered newFormControlWidth"
                                      (valueChange)="_comboValueChange($event,i)">
                                    </kendo-combobox>
                                  </div>
                                </div>
                              }
                            </div>
                          </kendo-window>
                        }

                        @if (_deactivatedFieldsForm) {
                          <kendo-window title="Deactivated Fields" (close)="_closeInactiveFields()">
                            <div class="row no_row_margin margin-top-30">
                              <div class="col-12 margin-top-10">
                                <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                  <kendo-grid-column field="name" title="Fields Name">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="formTab.name" title="Tab Name">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      {{dataItem.createdOn | dateFormat}}
                                    </ng-template>
                                  </kendo-grid-column>
                                  <kendo-grid-column field="lastUpdatedOn" title="Deactivation Date" type="date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      {{dataItem.lastUpdatedOn | dateFormat}}
                                    </ng-template>
                                  </kendo-grid-column>
                                  <kendo-grid-column field="Command" title="Command">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      <div class="action-button action-button-deactivate" (click)="_reactivate(dataItem)">
                                        <div class="action-button-icon">
                                          <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                        </div>
                                        <div class="edit-icon-text">Reactivate</div>
                                      </div>
                                    </ng-template>
                                  </kendo-grid-column>
                                </kendo-grid>
                              </div>
                            </div>
                          </kendo-window>
                        }

                        @if (_SIDActiveForm) {
                          <kendo-window
                            title="Dispose History"
                            (keydown.enter)="$event.preventDefault()"
                            (close)="DisposeHistoryOnClose()"
                            class="fullWidthFormForm">
                            <div class="col-12">
                              <div class="asap-section-container zero-padding">
                                <div class="row zeromarginRow">
                                  <div class="col-12 zeroPaddingColumn">
                                    <div class="header-section-gray">
                                      Dispose History - Graph
                                      <span [ngClass]="isDisposeHistoryChartExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                        class="float-right pointer-click mt-2 mr-2"
                                      (click)="ExpandCollapseDisposeHistoryChart(isDisposeHistoryChartExpanded)"></span>
                                    </div>
                                  </div>
                                </div>
                                @if (isDisposeHistoryChartExpanded) {
                                  <div
                                    class="graph-container-display">
                                    <apx-chart [title]="disposeToChart.title"
                                      [series]="disposeToChart.series"
                                      [chart]="disposeToChart.chart"
                                      [xaxis]="disposeToChart.xaxis"
                                      [stroke]="disposeToChart.stroke"
                                    [dataLabels]="disposeToChart.dataLabels"></apx-chart>
                                  </div>
                                }
                              </div>
                              <div class="asap-section-container zero-padding">
                                <div class="row zeromarginRow">
                                  <div class="col-12 zeroPaddingColumn">
                                    <div class="header-section-gray">
                                      Dispose History - Grid
                                      <span [ngClass]="isDisposeHistoryGridExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                        class="float-right pointer-click mt-2 mr-2"
                                      (click)="ExpandCollapseDisposeHistoryGrid(isDisposeHistoryGridExpanded)"></span>
                                    </div>
                                  </div>
                                  @if (isDisposeHistoryGridExpanded) {
                                    <div
                                      class="col-12 zeroPaddingColumn">
                                      <div class="col-12 mt-1 mb-2 chart-code-description">
                                        <span>Dispose code : {{_model.code}}</span>
                                      </div>
                                      @if (_disposeHistoryGridColumns) {
                                        <asap-grid-layout
                                          [page]="'stockItems'"
                                          [pagingEnabled]="false"
                                          [sortingEnabled]="true"
                                          [filteringEnable]="true"
                                          [headerEnable]="true"
                                          [importEnable]="true"
                                          [exportExcelEnable]="true"
                                          [exportPDFEnable]="true"
                                          [orderEnable]="true"
                                          [headerTitle]="'Dispose History'"
                                          [enableSiteSelection]="false"
                                          [resolver]="_getDisposeHistoriesByDispostTo"
                                          class="ListGrid"
                                          [refreshInitData]="true"
                                          [withHeader]="false">
                                          @for (column of _disposeHistoryGridColumns; track column) {
                                            @if (column.selected) {
                                              @if (!column.isTemplate) {
                                                <ng-template pageListColumn
                                                  [field]="column.field"
                                                  [name]="column.title"
                                                  [type]="column.type"
                                                  let-item>
                                                  @if (column.type == 'date') {
                                                    {{ item[column.field] | date }} {{
                                                    item[column.field] |
                                                    date:'shortTime'
                                                    }}
                                                  }
                                                  @if (column.type != 'date' && column.type == 'id') {
                                                    {{item[column.field]}}
                                                  }
                                                  @if (column.field == 'fromLocation.code') {
                                                    {{item.fromLocation?.code}}
                                                  }
                                                  @if (column.field == 'disposeTo.code') {
                                                    {{item.disposeTo?.code}}
                                                  }
                                                  @if (column.field == 'fromLocation.site.name') {
                                                    {{item.fromLocation?.site?.name}}
                                                  }
                                                  @if (column.field == 'fromLocation.site.id') {
                                                    {{item.fromLocation?.site?.id}}
                                                  }
                                                  @if (column.field == 'stock.number') {
                                                    {{item.stock?.number}}
                                                  }
                                                  @if (column.field == 'stock.description') {
                                                    {{item.stock?.description}}
                                                  }
                                                  @if (column.field == 'stock.category.description') {
                                                    {{item.stock?.category?.description}}
                                                  }
                                                  @if (column.field == 'stock.category.id') {
                                                    {{item.stock?.category?.id}}
                                                  }
                                                  @if (column.field == 'stock.inventoryUnitOfMeasure.code') {
                                                    {{item.stock?.inventoryUnitOfMeasure?.code}}
                                                  }
                                                  @if (column.field == 'stock.inventoryUnitOfMeasure.unitName') {
                                                    {{item.stock?.inventoryUnitOfMeasure?.unitName}}
                                                  }
                                                  @if (column.field == 'user.username') {
                                                    {{item.user?.username}}
                                                  }
                                                  @if (column.field == 'stockLocation.id') {
                                                    {{item.stockLocation?.id}}
                                                  }
                                                  @if (column.field == 'stockLocation.expirationDate') {
                                                    {{$safeNavigationMigration(item.stockLocation?.expirationDate) | dateFormat}}
                                                  }
                                                  @if (column.field == 'fromLocation.description') {
                                                    {{item.fromLocation?.description}}
                                                  }
                                                  @if (column.field == 'stock.costInfo.cost') {
                                                    {{$safeNavigationMigration(item.stock?.costInfo?.cost) | costFormat}}
                                                  }
                                                  @if (column.field == 'stock.costInfo.invCost') {
                                                    {{
                                                    ($safeNavigationMigration(item.stock?.costInfo?.cost) /
                                                    $safeNavigationMigration(item.stock?.receiveUnitOfMeasure?.multiplier) *
                                                    $safeNavigationMigration(item.stock?.inventoryUnitOfMeasure?.multiplier)) |
                                                    costFormat
                                                    }}
                                                  }
                                                  @if (column.field == 'stock.extendedCost') {
                                                    {{
                                                    ($safeNavigationMigration(item.stock?.costInfo?.cost) /
                                                    $safeNavigationMigration(item.stock?.receiveUnitOfMeasure?.multiplier) *
                                                    $safeNavigationMigration(item.stock?.inventoryUnitOfMeasure?.multiplier) *
                                                    item.quantityDisposed) | costFormat
                                                    }}
                                                  }
                                                  @if (column.field == 'stock.generalDescription') {
                                                    {{item.stock?.generalDescription}}
                                                  }
                                                  @if (column.field == 'inventoryNumber') {
                                                    {{item.inventoryNumber}}
                                                  }
                                                  @if (column.field == 'notes') {
                                                    {{item.notes}}
                                                  }
                                                  @if (column.field == 'id') {
                                                    {{item.stockDisposeId |number:'9.0-0' |removeComma}}
                                                  }
                                                </ng-template>
                                              }
                                            }
                                          }
                                        </asap-grid-layout>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="col-12 margin-top-10">
                              <button kendoButton
                                class="steps_buttons_class"
                                (click)="DisposeHistoryOnClose()">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                  <span>close</span>
                                </button>
                              </div>
                            </kendo-window>
                          }

                          @if (_isEditForms) {
                            <asap-edit-forms
                              (close)="_onCloseEditForms($event)"
                              (saved)="_closeCustomFields()"
                              [page]="_page"
                              [permissionScope]="_permissionScope">
                            </asap-edit-forms>
                          }
                          @if (_deactivatedFormTabsForm) {
                            <kendo-window
                              title="Deactivated Forms"
                              (close)="_closeInactiveFormTabs()"
                              style="z-index: 10050;">
                              <div class="row no_row_margin margin-top-30">
                                <div class="col-12 margin-top-10">
                                  <kendo-grid [data]="_deactivatedFormTabsGridData" [scrollable]="'none'">
                                    <!-- <kendo-grid-column field="name" title="Fields Name">
                                  </kendo-grid-column> -->
                                  <kendo-grid-column field="name" title="Tab Name">
                                  </kendo-grid-column>
                                  <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      {{dataItem.createdOn | dateFormat}}
                                    </ng-template>
                                  </kendo-grid-column>
                                  <kendo-grid-column field="lastUpdatedOn"
                                    title="Deactivation Date"
                                    type="date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      {{dataItem.lastUpdatedOn | dateFormat}}
                                    </ng-template>
                                  </kendo-grid-column>
                                  <kendo-grid-column field="Command" title="Command">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                      <div class="action-button action-button-deactivate"
                                        (click)="_reactivateFormTab(dataItem)">
                                        <div class="action-button-icon">
                                          <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                        </div>
                                        <div class="edit-icon-text">Reactivate</div>
                                      </div>
                                    </ng-template>
                                  </kendo-grid-column>
                                </kendo-grid>
                              </div>
                            </div>
                          </kendo-window>
                        }
